"use strict";

import "regenerator-runtime";

import "../scss/main.scss";

/**
 * jQuery scripts
 */

(function ($) {
	"use strict";

	var rtl = $("body").hasClass("rtl");

	$(document).ready(function () {
		sliderSlider();
		$(".page-preloader-wrapper").stop().fadeOut(500);
	});

	/**
	 * Product search autocomplete
	 */
	var searchRequest;
	$(".search-autocomplete").autoComplete({
		minChars: 3,
		source: function (term, suggest) {
			try {
				searchRequest.abort();
			} catch (e) {}
			searchRequest = $.post(
				global.ajax,
				{
					search: term,
					action: "search_site",
				},
				function (res) {
					suggest(res.data);
				}
			);
		},
		renderItem: function (item, search) {
			// Faz replace de caracteres especiais para o HTML e procura expressão que foi digitada no campo de pesquisa
			search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
			var re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
			// Retorna item do autocomplete
			return (
				'<div class="autocomplete-suggestion" data-val="' +
				item["sku"] +
				'">' +
				'<div class="image">' +
				item["img"] +
				"</div>" +
				'<div class="desc">' +
				'<div class="sku">' +
				item["sku"] /*.replace(re, "<b>$1</b>")*/ +
				"</div>" +
				'<div class="title">' +
				item["title"] +
				"</div>" +
				'<div class="linha">' +
				item["pa_linha"] +
				"</div>" +
				'<div class="aplicacoes">' +
				item["pa_aplicacoes"] +
				"</div>" +
				"</div>" +
				"</div>"
			);
		},
	});

	/**
	 * Product attribute dropdowns
	 */
	$(".dropdown-attribute").on("change", function () {
		var url = $(this).val();
		window.location = url;
	});

	/**
	 * Sliders configuration
	 *
	 * @param {*} slider
	 * @param {*} max
	 * @param {*} size
	 */
	function slickAutoResponsive(slider, max, size) {
		if (!max) max = 6;
		if (!size) size = 75;

		var width = slider.width();
		var count = Math.ceil(width / size);

		if (count < 1) count = 1;
		if (count > max) count = max;

		return count;
	}

	/**
	 * Sliders
	 */
	function sliderSlider() {
		var pager = function (el, i) {
			return "<a>" + i + "</a>";
		};

		$(".content_slider_ul").each(function () {
			var slider = $(this);
			var count = 1;
			var centerMode = false;

			slider.slick("unslick");

			if (slider.closest(".content_slider").hasClass("carousel")) {
				count = slickAutoResponsive(slider);

				$(window).bind("debouncedresize", function () {
					slider.slick(
						"slickSetOption",
						"slidesToShow",
						slickAutoResponsive(slider),
						false
					);
					slider.slick(
						"slickSetOption",
						"slidesToScroll",
						slickAutoResponsive(slider),
						true
					);
				});
			}

			if (slider.closest(".content_slider").hasClass("center")) {
				centerMode = true;
			}

			slider.slick({
				cssEase: "cubic-bezier(.4,0,.2,1)",
				dots: true,
				infinite: true,
				touchThreshold: 10,
				speed: 300,

				centerMode: centerMode,
				centerPadding: "20%",

				prevArrow:
					'<a class="button button_js slider_prev" href="#"><span class="button_icon"><i class="icon-left-open-big"></i></span></a>',
				nextArrow:
					'<a class="button button_js slider_next" href="#"><span class="button_icon"><i class="icon-right-open-big"></i></span></a>',

				adaptiveHeight: true,
				appendDots: slider.siblings(".slider_pager"),
				customPaging: pager,

				rtl: false,
				autoplay: true,
				autoplaySpeed: 5000,

				slidesToShow: count,
				slidesToScroll: count,

				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		});
	}
})(jQuery);
